import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import PaiLink from 'features/ui/base-components/pai-link';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import PaiButton from '../../ui/base-components/pai-button';
import PaiTooltip from 'features/ui/base-components/pai-tooltip';

interface Props {
  open: boolean;
  loading: boolean;

  handleClose(): void;

  handleDenyMessage(): void;

  handleDenyMessageAndDeactivateContact(): void;
}

const ConfirmDeclineMessageDialog: React.FC<Props> = ({ open, loading, handleClose, handleDenyMessage, handleDenyMessageAndDeactivateContact }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={open} classes={{ paper: classes.paper }} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('declineMessage')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Typography className={classes.text} mb={'16px'}>
          {t('declineMessageQuestion')}
        </Typography>
        <Stack gap={2}>
          <PaiTooltip placement={'right'} title={<Typography className={classes.text}>{t('deactivatedContactsNote')}</Typography>}>
            <div>
              <PaiButton
                text={t('declineMessageAndDeactivateContact')}
                border={'rounded'}
                fullWidth
                color={'error'}
                action={handleDenyMessageAndDeactivateContact}
                disabled={loading}
              />
            </div>
          </PaiTooltip>
          <PaiTooltip
            placement={'right'}
            title={<Typography className={classes.text}>{t('declineMessageNote', { buttonText: t('declineMessageAndGenerateAgain') })}</Typography>}
          >
            <div>
              <PaiButton text={t('declineMessageAndGenerateAgain')} border={'rounded'} fullWidth action={handleDenyMessage} disabled={loading} />
            </div>
          </PaiTooltip>
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: 'linear-gradient(to right, #5044FF, #4AA4FF)',
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '20px 24px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default ConfirmDeclineMessageDialog;
